<ideal-product-section
  i18n-title="@@products.alternates.label"
  title="Similar Products"
  navAnchorId="app.main-menu/products/details/alternates"
  navAnchorHeading="Product"
  i18n-navAnchorHeading="@@products.nav.product.heading"
  [navAnchorHidden]="hasContent() === false"
  class="padded"
>
  <ideal-product-long-description [productId]="id()"></ideal-product-long-description>
</ideal-product-section>
